import { createFileRoute } from '@tanstack/react-router'
import { LinksPage } from '~/features/integrations/LinksPage'
import { LINK_PROVIDERS, linksQuery, statusQuery, type LinkProvider } from '~/features/integrations/queries'
import { Gate, RouteError } from '~/features/integrations/shared'
import { mayAny } from '~/features/org/guard'

type Search = { quelle?: LinkProvider; erledigt?: true }
const SEE = ['integrations.manage', 'squad.write'] as const

export const Route = createFileRoute('/_app/verein/datenquellen/zuordnungen')({
  validateSearch: (s: Record<string, unknown>): Search => ({
    ...(LINK_PROVIDERS.includes(s.quelle as LinkProvider) ? { quelle: s.quelle as LinkProvider } : {}),
    ...(s.erledigt === true || s.erledigt === 'true' ? { erledigt: true as const } : {}),
  }),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    if (!(await mayAny(context.queryClient, [...SEE]))) return
    await Promise.all([
      context.queryClient.ensureQueryData(statusQuery()),
      context.queryClient.ensureQueryData(linksQuery(deps.quelle ?? 'all', !!deps.erledigt)),
    ])
  },
  component: Page,
  errorComponent: RouteError,
})

function Page() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <Gate anyOf={[...SEE]}>
      <LinksPage
        provider={search.quelle ?? 'all'}
        done={!!search.erledigt}
        onFilter={(next) =>
          navigate({
            search: { ...(next.provider === 'all' ? {} : { quelle: next.provider }), ...(next.done ? { erledigt: true as const } : {}) },
            replace: true,
          })
        }
      />
    </Gate>
  )
}
